module.exports = __webpack_public_path__ + "img/stick-o-vision-explainer.846e0260.png";